import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);
const vuexPersist = new VuexPersist({
    key: 'ns_main',
    storage: window.sessionStorage
});

export default new Vuex.Store({
    state: {
        menuActive: '',
        hasContent: true,
        faqData: []
    },
    mutations: {
        MENU_ACTIVE(state, payload) {
            state.menuActive = payload;
        },
        HAS_CONTENT(state, payload) {
            state.hasContent = payload;
        },
        FAQ_DATA(state, payload) {
            state.faqData = payload;
        }
    },
    actions: {
        setMenuActive(context, payload) {
            context.commit('MENU_ACTIVE', payload);
        },
        setHasContent(context, payload) {
            context.commit('HAS_CONTENT', payload);
        },
        setFaqData(context, payload) {
            context.commit('FAQ_DATA', payload);
        }
    },
    modules: {
    },
    plugins: [vuexPersist.plugin]
});
